import { jsx as n } from "react/jsx-runtime";
function h(t) {
  const C = t.width || "16", i = t.height || "16";
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: C,
      height: i,
      viewBox: "0 0 16 16",
      fill: "none",
      ...t,
      children: /* @__PURE__ */ n(
        "path",
        {
          d: "M8.00012 3.467L13.5303 13.0218H2.46996L8.00012 3.467ZM1.19942 12.2873C0.633921 13.2641 1.33896 14.4906 2.46996 14.4906H13.5303C14.6613 14.4906 15.3663 13.2641 14.8008 12.2873L9.27066 2.73258C8.70516 1.75581 7.29508 1.75581 6.72958 2.73258L1.19942 12.2873ZM7.26571 7.14643V8.61526C7.26571 9.01919 7.59619 9.34968 8.00012 9.34968C8.40405 9.34968 8.73454 9.01919 8.73454 8.61526V7.14643C8.73454 6.7425 8.40405 6.41201 8.00012 6.41201C7.59619 6.41201 7.26571 6.7425 7.26571 7.14643ZM7.26571 10.8185H8.73454V12.2873H7.26571V10.8185Z",
          fill: "currentColor"
        }
      )
    }
  );
}
function e(t) {
  const C = t.width || "16", i = t.height || "16";
  return /* @__PURE__ */ n(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: C,
      height: i,
      viewBox: "0 0 16 16",
      fill: "none",
      ...t,
      children: /* @__PURE__ */ n(
        "path",
        {
          d: "M7.3 4.5H8.7V5.9H7.3V4.5ZM8 11.5C8.385 11.5 8.7 11.185 8.7 10.8V8C8.7 7.615 8.385 7.3 8 7.3C7.615 7.3 7.3 7.615 7.3 8V10.8C7.3 11.185 7.615 11.5 8 11.5ZM8 1C4.136 1 1 4.136 1 8C1 11.864 4.136 15 8 15C11.864 15 15 11.864 15 8C15 4.136 11.864 1 8 1ZM8 13.6C4.913 13.6 2.4 11.087 2.4 8C2.4 4.913 4.913 2.4 8 2.4C11.087 2.4 13.6 4.913 13.6 8C13.6 11.087 11.087 13.6 8 13.6Z",
          fill: "currentColor"
        }
      )
    }
  );
}
export {
  e as C,
  h as T
};
